<template>

  <HeaderNav/>
  <h2>Lista de activos</h2>
  <ul class="assets">
      <li v-for="(asset, i) in assets" :key="'asset' + i" @click.stop="getRecord(call,$event)">

        <h2>{{ asset.name }}</h2>
        <div class="meta">
          <p>Velocidad: {{asset.speed }}</p>
          <p>Motor: {{asset.ignition }}</p>
          <p>Último reporte: {{asset.datetime }} ({{ asset.datetime_ago }})</p>
        </div>
        <div class="actions">
          <a href="javascript:void(0)" @click.stop="callTo(asset,$event)"><i data-feather="phone-outgoing"></i></a>
          <a :href="'sms:'+asset.phone+'?body=Reset123456'"><i data-feather="mail"></i></a>


        </div>
      </li>
    </ul>
    <section class="status">
      <a href="javascript:void(0)" class="btn" @click="closeStatus()"><i data-feather="x"></i></a>

      <div class="calling">
        <div class="loader">Conectando...</div>

          <p ref="statusText">Iniciando enlace seguro con <span ref="assetName"></span></p>
        </div>
    </section>
  <FooterNav/>
</template>


<script>
import HeaderNav from '@/components/HeaderNav.vue'
import FooterNav from '@/components/FooterNav.vue'
import axios from "axios";
import feather from 'feather-icons';

export default {
  components: {
      HeaderNav,FooterNav
    },
  data: () => ({
    selectedDate: [new Date(),new Date(new Date().getTime() + 9 * 24 * 60 * 60 * 1000)],
    assets: [],
    elPlayer: null,

  }),
  name: 'AboutPage',
  props: {
    msg: String
  },
  mounted(){

  },
  created() {
    axios({
        method: 'post',
        url: 'https://www.evotrack.com.mx/remote/json.assets.php',
        headers: { 'content-type': 'application/x-www-form-urlencoded'  },
        data: { cid: this.$root.user.id_client ,uid: this.$root.user.id_user, type: this.$root.user.type },
      }).then((result) => {
        console.log(result);
        this.assets = result.data.gprs;

      }).catch(function(){ });

  },
  updated(){
    this.$nextTick(function () {
      feather.replace();
    });
  },
   methods: {

    closeStatus(){
      let el = document.querySelector('section.status');
      el.classList.remove("active");
      this.$refs.statusText.classList.remove("fx");
    },

    callTo(item,el){
      let _self = this;
      console.log(item);
      this.$refs.assetName.innerHTML = item.name;
      this.$refs.statusText.classList.add("fx");
      this.$refs.statusText.innerHTML = 'Iniciando enlace seguro con <span ref="assetName">'+item.name+'</span>';
      let statusBox = document.querySelector('section.status');
      statusBox.classList.add("active");
      let qs = {
        access_token: this.vi_token,
        domain: this.vi_dom,
        caller_id : '528121880906',
        scenario_id : '51807',
        phone : this.$root.user.movil,
        variables: '{"number": '+item.phone+'}',
      }
      axios.post('https://kitapi-us.voximplant.com/api/v3/scenario/runScenario',{}, {
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
        params: qs,
      }).then((result) => {
        setTimeout(function(){ _self.$refs.statusText.innerHTML = "Enlazando llamada ->"; },4000);
      });
    },

    getRecord(item,e){



      const boxes = document.querySelectorAll('ul.assets li');
      boxes.forEach(box => { box.classList.remove("on"); });
      e.currentTarget.classList.add("on");




     },

   }
}
</script>

<style scoped>
@import url(~@/assets/loader.css);
h2 { text-transform: uppercase; color:#fbfbfb; font-size:12px; letter-spacing: 1px; text-align: left; font-weight: bold; text-indent: 5px; margin-bottom:20px; position:relative; text-indent:25px;}

ul.assets { max-width:100%; margin:auto; padding:0; padding-left:20px; padding-right:20px; padding-bottom:200px;}
ul.assets li { box-shadow:0px 0px 14px rgba(0,0,0,.15); width:100%; margin-bottom:20px; border-radius:6px;  display:inline-block; border:#2e323d solid 1px; border-radius:6px; overflow:hidden; color:#cdcdcd; position:relative;}
ul.assets li .meta { padding:15px; text-align: left;}
ul.assets li .meta p { margin:0; vertical-align: middle;;}
ul.assets li .meta svg { width:17px; height: 17px; margin-right: 6px; vertical-align: middle;;}
ul.assets li a.btn { background-color:#2e323d; border-radius:100px; width:35px; height:35px; position: absolute; right:10px; top:50px; color:#fff; line-height: 45px; text-align: center;;}
ul.assets li a.btn svg { width:20px; height: 20px; color:#00b589; }
ul.assets li h2 { background: #2e323d; color:#f7fbfa; font-size:14px; margin:0; padding:12px 10px; text-align:left; text-indent:0; }
ul.assets li.on { border:#00b589 solid 2px;}
ul.assets li.on h2 { background:#00b589; }
ul.assets li .actions { text-align:left; padding:15px; padding-top:0px; display:none;}
ul.assets li .actions a { background: #00b589; display:inline-block; padding:5px; border-radius:6px; color:#fff; text-align: center; line-height: 35px; width:35px; height: 35px; margin-right:15px; }
ul.assets li .actions a svg { width:18px; height: 18px; margin-left:-2px;}
ul.assets li.on .actions  { display:block; }




section.status { position: fixed; bottom:-160px; background-color: #00b589; width:100%; padding:25px 25px ;   transition: bottom .200s ease-in; text-align: center; }
section.status p { color:#fff; font-size: 20px; margin-bottom: 0px;}
section.status p span { font-weight: bold;}
section.status.active { bottom:61px;}
section.status a.btn {
  width:50px; height:50px; position: absolute;
  top:5px; right:5px; position: absolute;
  color:#fff;
  line-height: 60px;;
  border-radius: 100px;
  opacity:.8;
}


</style>
